import { createSlice } from "@reduxjs/toolkit";
import {
    userSignUp,
    userLogin,
    userForgotPassword,
    getBussinessProfileData,
    updateBussinessProfile,
    changePassword,
    getDashboardData,
    updateBussinessImage,
    getNotificationData,
    getAllSubscriptionPlan,
    getUserSubscriptionPlan,
    cancelSubscriptionPlan,
    getSubscriptionPlanHistory,
    purchaseSubscriptionPlan,
    upgradeSubscriptionPlan,
    getXeroLoginLink,
    pushInvoiceToXeroAction,
    markTooltipSeen
} from "../actions/authActions";

const TOOLTIP_SEEN_STORAGE_KEY = "fm_tooltip_seen_v1";
const loadTooltipSeen = () => {
    try {
        if (typeof window === "undefined" || !window.sessionStorage) return false;
        const raw = window.sessionStorage.getItem(TOOLTIP_SEEN_STORAGE_KEY);
        return raw === "true";
    } catch (_e) {
        return false;
    }
};

const initialState = {
    isLoading: false,
    isToggle: false,
    bussiness_profile: [],
    tooltipSeen: loadTooltipSeen(),
    dashBoardData: {},
    fcm: '',
    notificationData: [],
    subscriptionPlane: [],
    userSubscriptionPlane: [],
    subscriptionPlanHistory: []
};

export const authSlice = createSlice({
    name: "Auth",
    initialState: initialState,
    reducers: {
        saveFcmToken: (state, acton) => {
            state.fcm = acton?.payload;
        },
    },
    extraReducers: (builder) => {
        // userSignUp
        builder.addCase(userSignUp.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(userSignUp.fulfilled, (state, action) => {
            state.isLoading = false;
        });
        builder.addCase(userSignUp.rejected, (state, action) => {
            state.isLoading = false;
        });

        // userLogin
        builder.addCase(userLogin.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(userLogin.fulfilled, (state, action) => {
            state.isLoading = false;
            const tooltipSeenValue =
                action?.payload?.data?.userData?.tooltipSeen ??
                action?.payload?.data?.userData?.tooltip_seen ??
                action?.payload?.data?.userData?.toolTipSeen;
            if (typeof tooltipSeenValue === "boolean") {
                state.tooltipSeen = tooltipSeenValue;
            }
        });
        builder.addCase(userLogin.rejected, (state, action) => {
            state.isLoading = false;
        });

        // userForgotPassword
        builder.addCase(userForgotPassword.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(userForgotPassword.fulfilled, (state, action) => {
            state.isLoading = false;
        });
        builder.addCase(userForgotPassword.rejected, (state, action) => {
            state.isLoading = false;
        });

        // changePassword
        builder.addCase(changePassword.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(changePassword.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(changePassword.rejected, (state) => {
            state.isLoading = false;
        });

        // getBussinessProfileData
        builder.addCase(getBussinessProfileData.pending, (state, action) => {
            state.isLoading = true;
        });
        // builder.addCase(getBussinessProfileData.fulfilled, (state, action) => {
        //     const { data } = action?.payload || [];
        //     state.bussiness_profile = data ?? [];
        //     const tooltipSeenValue =
        //         data?.tooltipSeen ?? data?.tooltip_seen ?? data?.toolTipSeen;
        //     if (typeof tooltipSeenValue === "boolean") {
        //         state.tooltipSeen = tooltipSeenValue;
        //     }
        //     state.isLoading = false;
        // });
        builder.addCase(getBussinessProfileData.fulfilled, (state, action) => {
    const { data } = action?.payload || [];
    state.bussiness_profile = data ?? [];
    
    // ✅ Sirf false set karo agar abhi bhi false hai
    // True se kabhi false mat karo
    const tooltipSeenValue =
        data?.tooltipSeen ?? data?.tooltip_seen ?? data?.toolTipSeen;
    if (typeof tooltipSeenValue === "boolean" && state.tooltipSeen !== true) {
        state.tooltipSeen = tooltipSeenValue;
    }
    
    state.isLoading = false;
});
        builder.addCase(getBussinessProfileData.rejected, (state, action) => {
            state.isLoading = false;
        });

        // markTooltipSeen
        builder.addCase(markTooltipSeen.fulfilled, (state, action) => {
            state.tooltipSeen = true;
        });

        // updateBussinessProfile
        builder.addCase(updateBussinessProfile.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(updateBussinessProfile.fulfilled, (state, action) => {
            state.isLoading = false;
        });
        builder.addCase(updateBussinessProfile.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getDashboardData
        builder.addCase(getDashboardData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getDashboardData.fulfilled, (state, action) => {
            const { data } = action?.payload || {};
            state.dashBoardData = data ?? {};
            state.isLoading = false;
        });
        builder.addCase(getDashboardData.rejected, (state, action) => {
            state.isLoading = false;
        });

        // updateBussinessImage
        builder.addCase(updateBussinessImage.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(updateBussinessImage.fulfilled, (state, action) => {
            state.isLoading = false;
        });
        builder.addCase(updateBussinessImage.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getNotificationData
        builder.addCase(getNotificationData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getNotificationData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.notificationData = data?.notifications ?? [];
            state.isLoading = false;
        });
        builder.addCase(getNotificationData.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getAllSubscriptionPlan
        builder.addCase(getAllSubscriptionPlan.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getAllSubscriptionPlan.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.subscriptionPlane = data ?? [];
            state.isLoading = false;
        });
        builder.addCase(getAllSubscriptionPlan.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getUserSubscriptionPlan
        builder.addCase(getUserSubscriptionPlan.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getUserSubscriptionPlan.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.userSubscriptionPlane = data ?? [];
            state.isLoading = false;
        });
        builder.addCase(getUserSubscriptionPlan.rejected, (state, action) => {
            state.isLoading = false;
        });

        // cancelSubscriptionPlan
        builder.addCase(cancelSubscriptionPlan.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(cancelSubscriptionPlan.fulfilled, (state, action) => {
            state.isLoading = false;
        });
        builder.addCase(cancelSubscriptionPlan.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getSubscriptionPlanHistory
        builder.addCase(getSubscriptionPlanHistory.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getSubscriptionPlanHistory.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.subscriptionPlanHistory = data ?? [];
            state.isLoading = false;
        });
        builder.addCase(getSubscriptionPlanHistory.rejected, (state, action) => {
            state.isLoading = false;
        });

        // purchaseSubscriptionPlan
        builder.addCase(purchaseSubscriptionPlan.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(purchaseSubscriptionPlan.fulfilled, (state, action) => {
            state.isLoading = false;
        });
        builder.addCase(purchaseSubscriptionPlan.rejected, (state, action) => {
            state.isLoading = false;
        });

        // upgradeSubscriptionPlan
        builder.addCase(upgradeSubscriptionPlan.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(upgradeSubscriptionPlan.fulfilled, (state, action) => {
            state.isLoading = false;
        });
        builder.addCase(upgradeSubscriptionPlan.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getXeroLoginLink
        builder.addCase(getXeroLoginLink.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getXeroLoginLink.fulfilled, (state, action) => {
            const { data } = action?.payload ?? {};
            // window.open(data)
            window.location.href = data;
            state.isLoading = false;
        });
        builder.addCase(getXeroLoginLink.rejected, (state, action) => {
            state.isLoading = false;
        });

        // pushInvoiceToXeroAction
        builder.addCase(pushInvoiceToXeroAction.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(pushInvoiceToXeroAction.fulfilled, (state, action) => {
            const { data } = action?.payload ?? {};
            console.log({ data })
            state.isLoading = false;
        });
        builder.addCase(pushInvoiceToXeroAction.rejected, (state, action) => {
            state.isLoading = false;
        });
    },
});


export const { saveFcmToken } = authSlice.actions;
export default authSlice.reducer;
